import React, { useEffect, useState, useRef } from "react";
import "./App.css";

const ScrollFadeComponent = ({ children, offset = 50, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  const handleScroll = () => {
    const elementYPos = elementRef.current.getBoundingClientRect().top + window.scrollY;
    const scrollPosition = window.scrollY + window.innerHeight;

    // 스크롤 위치가 요소의 Y값 + offset 이상일 경우 애니메이션 트리거
    if (scrollPosition >= elementYPos + offset && !isVisible) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isVisible]);

  return (
    <div
      ref={elementRef}
      className={`scroll-fade ${isVisible ? "visible" : ""}`}
      style={{ transitionDelay: `${delay}ms` }} // delay를 적용
    >
      {children}
    </div>
  );
};

export default ScrollFadeComponent;
